/**
 * BookingListTable — the desktop data table (BON-130).
 *
 * Columns: REF · CUSTOMER (name+email) · WORKSHOP (name + date·time·venue) ·
 * REGION (metro + parent) · TICKETS · SOURCE · STATUS · TOTAL. Row → booking
 * detail; workshop name → workshop detail and venue name → venue detail, both
 * into the current dashboards shell and both stopping row propagation. The REF,
 * CUSTOMER and STATUS headers are sortable (they map to the contract's sort
 * fields); bookingDate sort is driven from the toolbar control since it has no
 * column.
 */
import type { BookingListItem, BookingSort, BookingSortDir } from '../../api/bookingsList';
import { type WorkshopShell } from '../dashboards/workshopDetailUrlFor';

import { TH } from './bookingListTableStyle';
import BookingSortHeader from './components/BookingSortHeader';
import BookingTableRow from './components/BookingTableRow';

interface Props {
  bookings: BookingListItem[];
  sort: BookingSort;
  dir: BookingSortDir;
  onSort: (field: BookingSort) => void;
  shell: WorkshopShell;
}

export function BookingListTable({ bookings, sort, dir, onSort, shell }: Props) {
  return (
    <div className="overflow-x-auto rounded-xl border border-stone-200 bg-white dark:border-stone-700 dark:bg-[#1a1f1c]">
      <table className="w-full text-sm">
        <thead className="border-b border-stone-200 dark:border-stone-700">
          <tr>
            <BookingSortHeader
              field="confirmationCode"
              label="Ref"
              sort={sort}
              dir={dir}
              onSort={onSort}
            />
            <BookingSortHeader
              field="customer"
              label="Customer"
              sort={sort}
              dir={dir}
              onSort={onSort}
            />
            <th className={TH}>Workshop</th>
            <th className={TH}>Region</th>
            <th className={TH}>Tickets</th>
            <th className={TH}>Source</th>
            <BookingSortHeader
              field="status"
              label="Status"
              sort={sort}
              dir={dir}
              onSort={onSort}
            />
            <th className={`${TH} text-right`}>Total</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-stone-100 dark:divide-stone-700/60">
          {bookings.map((b) => (
            <BookingTableRow key={b.id} b={b} shell={shell} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
